import { reactAnalytics } from "@asurion-core/eventualize-react";
import { useFeedbackDraftStore } from "@asurion-core/expert-workspace-feedback";
import { notifications } from "@mantine/notifications";

import { showErrorNotification } from "../errors";
import { CheckIcon } from "./checkIcon";

const showFeedbackSavedNotification = () => {
    const message = "Feedback saved";

    const id = notifications.show({
        title: " ",
        message,
        color: "dark.8",
        icon: <CheckIcon />,
        withCloseButton: true,
        autoClose: 3000,
    });

    void reactAnalytics.dispatcher.dispatchUserAction("Notification_View", "NotificationsSystem", {
        notificationType: "Success",
        notificationSubType: "FeedbackSaved",
        notificationId: id,
        notificationText: message,
    });
};
export type FeedbackNotificationType = "success" | "error";

// Reads the draft at call time instead of subscribing, so the caller does not re-render on every draft change
const triggerFeedbackNotification = (type: FeedbackNotificationType) => {
    if (useFeedbackDraftStore.getState().draft.description && type === "success") showFeedbackSavedNotification();
    else if (type === "error") showErrorNotification("FeedbackSavedError");
};

export const useFeedbackNotification = (): ((type: FeedbackNotificationType) => void) => triggerFeedbackNotification;
